import { Box, Button, DialogActions, Modal, Stack, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import { LanguageContext } from '../util/LanguageContext'

type ModalConfirmOkDialogProps = {
  open: boolean
  text: string
  onClick: () => void
}

export const ModalConfirmOkDialog: React.FC<ModalConfirmOkDialogProps> = props => {
  const { open, text, onClick } = props
  const [isOpen, setIsOpen] = useState(open)
  // 文字列変換用
  const translation = useContext(LanguageContext)

  const handleClose = (event: React.MouseEvent<HTMLInputElement>, reason: 'backdropClick') => {
    if (reason === 'backdropClick') return
    onClick()
    setIsOpen(false)
  }

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '31%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: 'auto',
          minHeight: '100px',
          width: '640px',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 16,
        }}
      >
        <Stack justifyContent="center" alignItems="center">
          <Typography
            sx={{
              mt: '38px',
              mr: '40px',
              ml: '40px',
              mb: '19px',
              color: '#282828',
              font: 'normal normal normal 21px/32px Noto Sans JP',
              wordWrap: 'break-word',
              textAlign: 'left',
            }}
          >
            {translation[text].split(/(。|、|\.)/).map((line, index, arr) => {
              if (index % 2 === 0) {
                // 偶数番目の要素はテキスト
                return (
                  <React.Fragment key={index}>
                    {line}
                    {index < arr.length - 1 && arr[index + 1]}
                    {(line.length > 0 || index < arr.length - 1) && <br />}
                  </React.Fragment>
                )
              }
              return null // 奇数番目の要素（分割文字）は無視する
            })}
          </Typography>
          <DialogActions>
            <Box mb="16px" display="flex" justifyContent="center">
              <Button
                type="submit"
                onClick={onClick}
                sx={{
                  // left: "50%",
                  height: '49px',
                  width: '181px',
                  font: 'normal normal bold 21px/29px Noto Sans JP',
                  color: '#FFFFFF',
                  background: '#282828',
                  '&:hover': {
                    background: '#282828',
                    opacity: 0.8,
                  },
                  borderRadius: '10px',
                }}
              >
                {translation['button_ok']}
              </Button>
            </Box>
          </DialogActions>
        </Stack>
      </Box>
    </Modal>
  )
}
